import * as React from 'react'
import { useSelector } from 'react-redux'
import { USD } from '../../helpers/NumberHelper'
import CategoryImage from '../CategoryImage'
import { Link } from 'gatsby'
import EstimatedTotalPrice from '../products/EstimatedTotalPrice'
import finalPrice from '../../helpers/product/finalPrice'

const SideCart = () => {
  const cartLength = useSelector(state => state.cart.products.length)
  // const cartTotal = useSelector(state => state.cart.total)
  const cartProducts = useSelector(state => state.cart.products)

  return (
    <div
      className={
        'absolute hidden md:block right-0 rounded-lg border border-gray-300 pt-20 py-5 top-10 bg-white duration-300 w-96 shadow-lg z-20'
      }
    >
      <p className="text-sm absolute top-0 left-0 w-96 py-2 bg-gray-200 rounded-t-lg border-b border-gray-400">
        <b className="text-2xl font-black ">SHOPPING CART</b>
        <br />
        {cartLength} Item{cartLength > 1 ? 's' : ''} in Cart
      </p>
      <div className="calc-h overflow-x-hidden overflow-y-auto px-5">
        {cartProducts.map((product, index) => (
          <div
            key={`${index}-${product.sku}`}
            className="grid grid-cols-3 text-left py-3 gap-4 border-b border-gray-200"
          >
            <div className="w-28 h-28 col-span-1 aspect-square">
              <CategoryImage
                normal={product.image}
                sku={product.sku}
                title={product.title}
                alt={product.name}
                url={product.url}
                imgStyle={{ objectFit: 'contain' }}
                className={'w-full h-full aspect-square '}
                productType={product.productType}
              />
            </div>
            {product.brand !== 'Estate Jewelry' ? (
              <p className=" col-span-2 font-normal">
                <b className="uppercase">{product.brand}</b>
                <br />
                <p>{product.model}</p>
                <i>{product.model_no}</i>
                <br />
                {USD(finalPrice(product))}
              </p>
            ) : (
              <p className=" col-span-2 font-normal">
                <b className=" text-black wrap line-clamp-3">{product.title}</b>
                <i>{product.model}</i>
                <br />
                {USD(finalPrice(product))}
              </p>
            )}
          </div>
        ))}
      </div>
      {/* <p className="text-right my-3 px-5">Subtotal: {USD(cartTotal)}</p> */}
      <EstimatedTotalPrice products={cartProducts} summary={true} />
      <Link
        to={'/checkout'}
        className="w-10/12 block mx-auto rounded-full bg-red-700 py-3 font-black text-white hover:bg-red-800"
      >
        CHECKOUT
      </Link>
    </div>
  )
}
export default SideCart
